import { Link, graphql, StaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import React from 'react'

import './header.scss'

import logo from '../images/icons/logo.svg'
import logoLight from '../images/icons/logo-light.svg'
import menu from '../images/icons/menu.svg'
import menuClose from '../images/icons/menu-close.svg'

const handleMenuClick = (e, fullpageApi, preventDefault = true) => {
  preventDefault && e.preventDefault()
  if (document.body.classList.contains('nav-active')) {
    document.body.classList.remove('nav-active')
    fullpageApi && fullpageApi.setAllowScrolling(true)
    fullpageApi && fullpageApi.setKeyboardScrolling(true)
  } else {
    document.body.classList.add('nav-active')
    fullpageApi && fullpageApi.setAllowScrolling(false)
    fullpageApi && fullpageApi.setKeyboardScrolling(false)
  }
}

const handleShareClick = e => {
  e.preventDefault()
  let shareContainer = e.target.parentNode
  if (shareContainer.classList.contains('is-expanded')) {
    shareContainer.classList.remove('is-expanded')
  } else {
    shareContainer.classList.add('is-expanded')
  }
}

// TODO: Change these three share urls to the final url before launch (e.g. "https://www.mckinsey.com/careers-quiz/")
const shareWithTwitter = e => {
  e.preventDefault()

  let tweetConfig = serialize({
    url: 'https://www.mckinsey.com/spContent/CareersQuiz/index.html',
    title:
      'Take this quick 10-question quiz to discover the career path at McKinsey that best fits you.',
  })

  // eslint-disable-next-line
  let windowObjectReference
  windowObjectReference = window.open(
    'https://api.addthis.com/oexchange/0.8/forward/twitter/offer?' +
      tweetConfig,
    'Share with Twitter',
    'resizable,scrollbars,status,width=575,height=252'
  )
}

const shareWithFacebook = e => {
  e.preventDefault()

  let facebookConfig = serialize({
    url: 'https://www.mckinsey.com/spContent/CareersQuiz/index.html',
    title:
      'Take this quick 10-question quiz to discover the career path at McKinsey that best fits you.',
  })

  // eslint-disable-next-line
  let windowObjectReference
  windowObjectReference = window.open(
    'https://api.addthis.com/oexchange/0.8/forward/facebook/offer?' +
      facebookConfig,
    'Share with Facebook',
    'resizable,scrollbars,status,width=575,height=252'
  )
}

const shareWithLinkedIn = e => {
  e.preventDefault()

  let linkedInConfig = serialize({
    url: 'https://www.mckinsey.com/spContent/CareersQuiz/index.html',
    title:
      'Take this quick 10-question quiz to discover the career path at McKinsey that best fits you.',
  })

  // eslint-disable-next-line
  let windowObjectReference
  windowObjectReference = window.open(
    'https://api.addthis.com/oexchange/0.8/forward/linkedin/offer?' +
    linkedInConfig,
    'Share with LinkedIn',
    'resizable,scrollbars,status,width=575,height=575'
  )
}

const serialize = obj => {
  let str = []
  for (let p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
    }
  return str.join('&')
}

const Header = ({ fullpageApi }) => (
  <StaticQuery
    query={graphql`
      query NavImageQuery {
        navBackgroundImage: file(relativePath: { eq: "nav-background.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 2000) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => (
      <>
        <header className="top-bar">
          <Link
            to="#"
            onClick={e => handleMenuClick(e, fullpageApi)}
            className="menu-toggle"
          >
            <img src={menu} alt="Open Navigation Menu" className="icon-menu" />
          </Link>
          <img src={logo} alt="McKinsey &amp; Company" className="logo" />
          <div className="share-menu">
            <Link
              to="#"
              className="share-toggle"
              onClick={e => handleShareClick(e)}
            />
            <div className="share-links">
              <button
                className="social-twitter icon"
                onClick={e => shareWithTwitter(e)}
              />
              <button
                className="social-facebook icon"
                onClick={e => shareWithFacebook(e)}
              />
              <button
                className="social-linkedin icon"
                onClick={e => shareWithLinkedIn(e)}
              />
            </div>
          </div>
        </header>
        <div className="nav-curtain dark-theme">
          <div className="nav-bg-image">
            <Img fluid={data.navBackgroundImage.childImageSharp.fluid} />
          </div>
          <div className="nav-content">
            <div className="nav-top-bar">
              <Link
                to="#"
                onClick={e => handleMenuClick(e, fullpageApi)}
                className="menu-toggle"
              >
                <img
                  src={menuClose}
                  alt="Close Navigation Menu"
                  className="icon-menu-close"
                />
              </Link>
              <div className="logo-container">
                <img
                  src={logoLight}
                  alt="McKinsey &amp; Company"
                  className="logo"
                />
              </div>
            </div>
            <div className="nav-link-section">
              <ul className="primary-links">
                <li>
                  <Link
                    to="/"
                    className="link-with-arrow"
                    onClick={e => handleMenuClick(e, fullpageApi, false)}
                  >
                    <span>Take our Careers Quiz</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/explore/"
                    className="link-with-arrow"
                    onClick={e => handleMenuClick(e, fullpageApi, false)}
                  >
                    <span>Explore our career paths</span>
                  </Link>
                </li>
                <li>
                  <a
                    href="https://mckinsey.com/careers"
                    className="link-with-arrow"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>Visit our Careers Site</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.mckinsey.com/careers/search-jobs"
                    className="link-with-arrow"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>Search all of our 500+ job opportunities</span>
                  </a>
                </li>
              </ul>
              <hr />
              <ul className="social-links">
                <li>
                  <a
                    href="https://www.mckinsey.com/careers/meet-our-people/careers-blog"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Careers Blog
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/mckinsey"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Facebook
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/mckinseyco/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Instagram
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    )}
  />
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: '',
}

export default Header
